import script from "./Root.vue?vue&type=script&setup=true&lang=ts"
export * from "./Root.vue?vue&type=script&setup=true&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=31e2e2a9&lang=css"

const __exports__ = script;

export default __exports__